import { Action } from '@ngrx/store';
import { AuthActionType } from 'app/core/authentication/state/actions/auth-action-type.enum';

export class LoadToken implements Action {
  public readonly type: AuthActionType = AuthActionType.LoadToken;
  public readonly payload: any = undefined;
}

export class LoadTokenCompleted implements Action {
  public readonly type: AuthActionType = AuthActionType.LoadTokenCompleted;

  constructor(public readonly payload: string) { }
}

export class LoadTokenFailed implements Action {
  public readonly type: AuthActionType = AuthActionType.LoadTokenFailed;

  constructor(public readonly payload: string) { }
}
